// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth'
  },
  {
    action: 'read',
    subject: 'Menus'
  },
  {
    action: 'read',
    subject: 'Doc'
  },
  {
    action: 'read',
    subject: 'Dashboards'
  }
]

export const _ = undefined
